// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.height-question .height-question-inline-label {
    padding-right: 20px;
    padding-left: 5px;
}

.height-question .height-question-inputs {
    display: flex;
    justify-content: left;
    align-items: center;
}

.height-question .height-question-feet {
    width: 50px;
}

.height-question .height-question-inches {
    width: 60px;
}

.height-question .height-question-centimeters {
    width: 70px;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/HeightQuestion/HeightQuestion.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".height-question .height-question-inline-label {\n    padding-right: 20px;\n    padding-left: 5px;\n}\n\n.height-question .height-question-inputs {\n    display: flex;\n    justify-content: left;\n    align-items: center;\n}\n\n.height-question .height-question-feet {\n    width: 50px;\n}\n\n.height-question .height-question-inches {\n    width: 60px;\n}\n\n.height-question .height-question-centimeters {\n    width: 70px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
